<template>
  <!-- NOTE: v-model.lazy is used because binding to the "input" event (i.e. without the "lazy"
    modifer), when combined with the "autoUnmask" input mask option, causes the cursor to jump to
    the end after each keypress (i.e. whenever the value changes). -->
  <input type="text"
    inputmode="decimal"
    v-mask="{
      alias: 'currency',
      autoUnmask: true,
      prefix: '$ '
    }"
    v-focus="hasFocus"
    v-model.number="model"
  />
</template>

<script>
import focusable from '@ssi/vue-common/src/mixins/focusable';

export default {
  mixins: [focusable],

  props: {
    modelValue: [Number, String]
  },

  emits: ['update:modelValue'],

  computed: {
    model: {
      get: ({ modelValue }) => modelValue,

      set(newValue) {
        this.$emit('update:modelValue', newValue);
      }
    }
  }
};
</script>
